import React from 'react';
import useAnalytics from 'helpers/useAnalytics';
import { useDispatch, useSelector } from 'react-redux';
import getOnboardingTasks from 'fetches/getOnboardingTasks';
import makeUpdateOnboardingTask from 'fetches/makeUpdateOnboardingTask';
import { toggleTaskCompletion, setSlideKey, State } from 'store/onboarding';
import useTask from 'components/onboarding/useTask';

import makeStyles from '@material-ui/core/styles/makeStyles';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';

import { LIST_SLIDE_KEY, CHEERS_SLIDE_KEY } from 'components/onboarding/constants';

function TaskDetailHeading() {
  const classes = useStyles();
  const analytics = useAnalytics();
  const onboardingState: State = useSelector((state: any) => state.onboarding);
  const taskToShow = useTask();
  const { taskIdInFocus, slideKey, bubbleOpen: open } = onboardingState;

  const isCelebrating = slideKey === CHEERS_SLIDE_KEY;

  if (!taskToShow) {
    return null;
  }

  const dispatch = useDispatch();

  const handleBackToList = () => {
    dispatch(setSlideKey(LIST_SLIDE_KEY));
    dispatch(getOnboardingTasks());
  };

  const handleBackToTaskDetail = () => {
    // @ts-ignore
    dispatch(setSlideKey(taskIdInFocus));
  };

  const { id: taskId, categoryId, isComplete, allowManualComplete } = taskToShow;

  const updateTask = makeUpdateOnboardingTask(taskId);

  const handleToggleTaskCompletion = () => {
    dispatch(updateTask({ isComplete: !isComplete }));
    dispatch(toggleTaskCompletion(categoryId, taskId));

    if (!isComplete) {
      dispatch(setSlideKey(CHEERS_SLIDE_KEY));
      analytics.track('Onboarding Step Marked complete', {
        category: 'AD - Onboarding',
        label: taskToShow.title,
      });
    } else {
      // @ts-ignore
      dispatch(setSlideKey(taskIdInFocus));
      analytics.track('Onboarding Step Marked incomplete', {
        category: 'AD - Onboarding',
        label: taskToShow.title,
      });
    }
  };

  return (
    <>
      <div className={classes.buttonContainer}>
        {isCelebrating ? (
          <Button onClick={handleBackToTaskDetail} className={classes.backButton}>
            Back to step details
          </Button>
        ) : (
          <Button onClick={handleBackToList} className={classes.backButton}>
            Back to task list
          </Button>
        )}
        {allowManualComplete && (
          <Button
            onClick={handleToggleTaskCompletion}
            size="small"
            color="secondary"
            className={classes.button}
          >
            Mark {isComplete ? 'Incomplete' : 'Complete'}
          </Button>
        )}
      </div>
      <Divider className={classes.divider} />
    </>
  );
}

const useStyles = makeStyles(theme => ({
  root: {},
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: theme.spacing(0.32),
    paddingBottom: theme.spacing(0.25),
  },
  backButton: {
    ...theme.typography.overline,
    paddingLeft: theme.spacing(0.25),
    paddingRight: theme.spacing(0.25),
  },
  divider: {
    width: '100%',
    marginLeft: 0,
  },
  button: {
    paddingLeft: theme.spacing(0.25),
    paddingRight: theme.spacing(0.25),
  },
}));

export default TaskDetailHeading;
